import { css } from 'styled-components';
import brand from './brand';
import { fluid } from './fluid';
import fonts from './fonts';
import scrollbars from './scrollbars';
import { ButtonReset } from './global';
import Bullet from '@img/icons/bullet.png';
export const headingStyles = css `
  ${fonts.ubuntu.regular};
  color: currentColor;
  letter-spacing: -1px;
`;
export const h1 = css `
  ${headingStyles};

  font-size: ${fluid(24, 36)};
  line-height: ${fluid(36, 48)};
`;
export const h2 = css `
  ${headingStyles};
  ${fonts.ubuntu.medium};

  font-size: 24px;
  line-height: 36px;
`;
export const h3 = css `
  ${headingStyles};
  ${fonts.ubuntu.bold};

  font-size: 18px;
  line-height: 24px;
`;
export const h4 = css `
  ${headingStyles};

  font-size: 18px;
  line-height: 24px;
`;
const paragraphStyles = css `
  ${fonts.ubuntu.regular};

  color: currentColor;
  margin: 0 0 ${fluid(16, 24)};
`;
export const paragraphLarge = css `
  ${paragraphStyles};

  font-size: ${fluid(16, 24)};
  line-height: ${fluid(26, 48)};
`;
export const paragraphRegular = css `
  ${paragraphStyles};

  font-size: ${fluid(16, 18)};
  line-height: ${fluid(22, 24)};
`;
export const paragraphSmall = css `
  ${paragraphStyles};

  font-size: ${fluid(12, 14)};
  line-height: ${fluid(16, 20)};
`;
export const link = css `
  display: inline;
  color: ${brand.primary.brightBlue};
  text-decoration: underline;
  text-decoration-color: ${brand.primary.brightBlue};
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: auto;
    outline-offset: 2px;
    outline-width: 1px;
    outline-style: solid;
  }
`;
export const blockquote = css `
  ${paragraphLarge};

  color: currentColor;
  text-align: left;
  position: relative;
  padding-left: ${fluid(58, 80)};
  background-size: ${fluid(42, 56)};
  background-repeat: no-repeat;
  background-position: top left;
`;
export const table = css `
  ${paragraphRegular};

  background: ${brand.primary.white};
  border-collapse: collapse;
  color: currentColor;
  margin-bottom: 1em;
  width: 100% !important;

  td,
  th {
    border-right: 2px solid ${brand.primary.white};
    padding: 12px 16px;
    text-align: left;
  }

  thead {
    tr {
      td,
      th {
        ${fonts.ubuntu.bold};

        color: ${brand.primary.white};
        text-transform: uppercase;
      }
    }
  }
`;
export const contentStyles = css `
  h1,
  h2,
  h3,
  h4,
  h5,
  p,
  strong,
  a {
    white-space: pre-line;
  }

  h1,
  .h1-styles {
    ${h1};
  }

  h2,
  .h2-styles {
    ${h2};
  }

  h3,
  .h3-styles {
    ${h3};
  }

  h4,
  .h4-styles {
    ${h4}
  }

  h5,
  .h5-styles {
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    ${fonts.ubuntu.bold};
    color: ${brand.secondary.mariner};
  }

  p {
    ${paragraphRegular}

    a {
      ${link};
    }
  }

  strong {
    ${fonts.ubuntu.bold};
  }

  .large {
    ${paragraphLarge}
  }

  .small {
    ${paragraphSmall}
  }

  a {
    ${link}
  }

  button,
  a.button {
    ${ButtonReset};
    cursor: pointer;
    background-color: ${brand.primary.brightBlue};
    border: 1px solid ${brand.primary.white};
    border-radius: 10px;
    color: ${brand.primary.white};
    display: inline;
    font-family: sans-serif;
    font-size: 13px;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
    text-decoration: none;
    -webkit-text-size-adjust: none;

    ${fonts.ubuntu.medium};

    padding: 0px 40px;
  }

  ol,
  ul {
    ${paragraphRegular};

    li {
      color: currentColor;
    }
  }

  ul {
    display: flex;
    flex-direction: column;
    gap: 12px;

    list-style: disc !important;

    &.double-chevron {
      list-style: none !important;

      li::before {
        content: '';
        color: ${brand.grey.base};
        display: inline-block;
        width: 0.9em;
        height: 0.9em;
        position: relative;
        top: 2px;
        margin-left: -1.2em;
        margin-right: 8px;
        background-image: url(${Bullet});
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
      }
    }
  }

  ol {
    display: flex;
    flex-direction: column;
    gap: 12px;

    li::before {
      content: '';
      color: ${brand.grey.base};
      display: inline-block;
      width: 1em;
      height: 1em;
      position: relative;
      top: 3px;
      margin-left: -1.2em;
      margin-right: 15px;
      background-image: url('data:image/svg+xml,<svg stroke="%23bccf00" fill="%23bccf00" stroke-width="0" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>');
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
    }
  }

  ol,
  ul {
    list-style: none;
    padding-left: 1.2em;
  }

  blockquote {
    ${blockquote};
  }

  hr {
    display: block;
    background: ${brand.grey.base};
    border: 0;
    height: 2px;
    margin: ${fluid(24, 32)} 0;
    padding: 0;
    width: 100%;
  }

  table {
    ${table};
  }

  .responsive-table {
    ${scrollbars};

    position: relative;
    overflow-x: auto;
  }

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;
